<template>
    <div role="status" class="max-w-sm animate-pulse col-span-full gap-0 mt-4 inline-flex flex-col self-center">
        <div class="h-2.5 bg-gdc-gray-200 rounded-full w-48 w-full mb-4"></div>
        <div class="h-2.5 bg-gdc-gray-200 rounded-full w-48 w-full mb-4"></div>
        <span class="sr-only">Loading...</span>
    </div>
</template>

<script>
export default {
    name: "PaginationSkeleton"
}
</script>

<style scoped>

</style>
